import { BaseService } from "./BaseService";
import {
  CreateCustomPageDto,
  CustomPage,
  UpdateCustomPageDto,
} from "@/types/custom-page";

class CustomPagesService extends BaseService {
  private basePath = "/custom-pages";

  async getCustomPages(): Promise<CustomPage[]> {
    return this.get<CustomPage[]>(this.basePath);
  }

  async getCustomPage(id: string): Promise<CustomPage> {
    return this.get<CustomPage>(`${this.basePath}/${id}`);
  }

  async createCustomPage(data: CreateCustomPageDto): Promise<CustomPage> {
    return this.post<CustomPage>(this.basePath, data);
  }

  async updateCustomPage(
    id: string,
    data: UpdateCustomPageDto,
  ): Promise<CustomPage> {
    return this.patch<CustomPage>(`${this.basePath}/${id}`, data);
  }

  async deleteCustomPage(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }
}

export const customPagesService = new CustomPagesService();
